var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 13.25a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5zm-1.666-12a.75.75 0 0 1 .75.75v5.667a5.084 5.084 0 0 1-10.167 0V2a.75.75 0 0 1 1.5 0v5.667a3.583 3.583 0 0 0 7.167 0V2a.75.75 0 0 1 .75-.75"
  })));
};
export default Svg16;